import axios from 'axios';

const apiBrasil = axios.create({
  baseURL: 'https://viacep.com.br/ws',
});

export default apiBrasil;
